import React from "react";
import useDebounce from "hooks/useDebounce";
import { activitySearchRtk } from "activityModule/apis/activitySearchRtk";
import ManageActivityPagination from "activityModule/components/ManageActivity/ManageActivityPagination";
import ManageActivityCard from "activityModule/components/ManageActivity/ManageActivityCard";
import { IDMCActivityWTourOptions } from "commonFnBcode/types/dmc.types";
import ActivityEditForm from "../../components/ManageActivity/ActivityEditForm";

function ManageActivity() {
  const [searchTerm, setSearchTerm, debouncedSearchTerm] = useDebounce(300);
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const { data, isFetching, isLoading } =
    activitySearchRtk.useFetchActivitesQuery({
      searchType: "quickSearch",
      search: debouncedSearchTerm,
      page,
      limit,
    });

  const activities = data?.result?.activities || [];
  const totalPages = data?.result?.totalPages || 0;

  const [editActivity, setEditActivity] = React.useState({
    isOpen: false,
    activity: null as IDMCActivityWTourOptions | null,
  });

  const handleEditActivity = (activity: IDMCActivityWTourOptions) => {
    setEditActivity({ isOpen: true, activity });
  };

  const handleSaveActivity = (updatedActivity: IDMCActivityWTourOptions) => {
    console.log("Saving activity:", updatedActivity);
    setEditActivity({ isOpen: false, activity: null });
  };

  return (
    <main className="container my-4">
      <ActivityEditForm
        show={editActivity.isOpen}
        onHide={() => setEditActivity({ isOpen: false, activity: null })}
        activity={editActivity.activity}
      />
      {/* Header Section */}
      <div className="mb-4">
        <h1 className="text-dark">Manage Activities</h1>
      </div>

      {/* Search Section */}
      <div className="row mb-4">
        <div className="col-md-6 col-lg-4">
          <div className="form-group">
            <label className="form-label text-dark fw-bold">
              Search Activities
            </label>
            <input
              id="searchInput"
              type="text"
              className="form-control"
              placeholder="Search by activity name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Loading State */}
      {isFetching && (
        <div className="d-flex justify-content-center py-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {/* Activities List */}
      {!isLoading && (
        <div className="row">
          {activities.length > 0 ? (
            activities.map((activity) => (
              <ManageActivityCard
                key={activity.id}
                activity={activity}
                setEditActivity={handleEditActivity}
              />
            ))
          ) : (
            <div className="col-12">
              <div className="alert alert-info text-center py-4">
                <i className="fas fa-info-circle fa-2x mb-3"></i>
                <h5>No activities found</h5>
                <p className="mb-0">
                  {debouncedSearchTerm
                    ? "Try adjusting your search criteria to find activities."
                    : "No activities available at the moment."}
                </p>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Pagination */}
      {!isFetching && activities.length > 0 && (
        <div className="mt-4">
          <ManageActivityPagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            limit={limit}
            setLimit={setLimit}
          />
        </div>
      )}
    </main>
  );
}

export default ManageActivity;
